import React, { FC } from 'react';
import { CourierVehicleType } from '../../context/couriers';
import courierMarkerBike from '@assets/JETMarkerBike.svg';
import courierMarkerEBike from '@assets/JETMarkerEBike.svg';
import courierBadgeBike from '@assets/JETBadgeBike.svg';
import courierBadgeEBike from '@assets/JETBadgeEBike.svg';
import courierMarkerCar from '@assets/JETMarkerCar.svg';
import courierBadgeCar from '@assets/JETBadgeCar.svg';
import courierMarkerScooter from '@assets/JETMarkerScooter.svg';
import courierBadgeScooter from '@assets/JETBadgeScooter.svg';
import useStyles from './styles';
import JetFontIcon, { JET_FONTICON_ALIASES } from '@src/shared/components/JetFontIcon';
import { OrderStatus } from '../../context/orders';
interface VehicleTypeIconProps {
  vehicleType?: CourierVehicleType;
  iconType?: 'MARKER' | 'BADGE';
  iconSize?:number;
  iconColor?:string;
  iconWeightBold?:boolean;
  orderStatus?: OrderStatus
}

export const VehicleTypeIcon: FC<VehicleTypeIconProps> = ({
  vehicleType,
  iconType = 'MARKER',
  iconSize,
  iconColor,
  iconWeightBold,
  orderStatus = OrderStatus.Unassigned
}) => {
  const classes = useStyles();

  const getCourierMarker = () => {
    switch (vehicleType) {
      case CourierVehicleType.Bike:
        return iconType === 'MARKER' ? courierMarkerBike : JET_FONTICON_ALIASES.BIKE_SMALL;
      case CourierVehicleType.Car:
        return iconType === 'MARKER' ? courierMarkerCar : JET_FONTICON_ALIASES.CAR;
      case CourierVehicleType.Scooter:
        return iconType === 'MARKER' ? courierMarkerScooter : JET_FONTICON_ALIASES.MOPED_SMALL;
      case CourierVehicleType.EBike:
        return iconType === 'MARKER' ? courierMarkerEBike : JET_FONTICON_ALIASES.MOPED_SMALL;
      default:
        return iconType === 'MARKER' ? courierMarkerBike : JET_FONTICON_ALIASES.BIKE_SMALL;
    }
  };
  return (
    iconType === 'MARKER' ? <img src={getCourierMarker()} className={`order-status-${orderStatus} ${classes.marker}`} alt="marker" /> : <JetFontIcon bold={iconWeightBold} color={iconColor} iconname={getCourierMarker()} size={iconSize} /> 
  );
};

export default VehicleTypeIcon;
